import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button, Tooltip, Icon, USER_INTERFACE_CIRCLE_CROSS_CANCEL } from '@bwoty-web/styleguide';

import './selectionBox.scss';

const SelectionBox = (props) => {
  const {
    onClose,
    buttonText,
    clearFilters,
    clearFilterText,
    showClearFiltersButton,
    disableButton,
    zeroHitTooltipText,
    showZeroHitsToolTip,
    closeZeroHitsToolTip,
  } = props;

  const PotentialClearFilterButton = showClearFiltersButton && (
    <Button
      className="iw-selection-box__button"
      onClick={clearFilters}
      data-gtm-tag="Clear filter"
    >
      {clearFilterText}
    </Button>
  );

  const ShowTripsButton = (
    <Button
      theme="primary"
      disabled={disableButton}
      onClick={!disableButton && onClose}
      className="iw-selection-box__button"
      data-gtm-tag="Show filtered trips"
    >
      {buttonText}
    </Button>
  );

  const filterButtonStyle = classNames(
    'iw-selection-box__item iw-selection-box__clear-filter',
    {
      'iw-selection-box__clear-filter--hidden': !PotentialClearFilterButton,
    },
  );

  const potentialTooltip = !!showZeroHitsToolTip && (
    <div className="iw-filter-zero-hit">
      <Tooltip className="iw-filter-zero-hit-tooltip" arrowVerticalPosition="bottom">
        <button
          type="button"
          onClick={closeZeroHitsToolTip}
          className="iw-filter-zero-hit-tooltip__text"
        >
          {zeroHitTooltipText}
          <Icon
            path={USER_INTERFACE_CIRCLE_CROSS_CANCEL}
            className="iw-filter-zero-hit-tooltip__close"
          />
        </button>
      </Tooltip>
    </div>
  );

  return (
    <div>
      {potentialTooltip}
      <ul className="iw-selection-box">
        <li className={filterButtonStyle}>{PotentialClearFilterButton}</li>
        <li className="iw-selection-box__item iw-selection-box__show-button">{ShowTripsButton}</li>
      </ul>
    </div>
  );
};

SelectionBox.propTypes = {
  onClose: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  clearFilters: PropTypes.func.isRequired,
  clearFilterText: PropTypes.string.isRequired,
  showClearFiltersButton: PropTypes.bool.isRequired,
  disableButton: PropTypes.bool.isRequired,
  zeroHitTooltipText: PropTypes.string.isRequired,
  showZeroHitsToolTip: PropTypes.bool.isRequired,
  closeZeroHitsToolTip: PropTypes.func.isRequired,
};

export default SelectionBox;
